import { useContext } from 'react'
import { SearchContext } from './search-context'
import { SearchInput as StyledSearchInput } from '../styled-components'

const SearchInput = ({ ...props }) => {
  const {
    variant,
    disabled,
    isOpenInput,
    inputRef,
    value,
    handleInputChange,
    handleFocus,
    handleOnBlur,
    ...contextProps
  } = useContext(SearchContext)

  return (
    <StyledSearchInput
      ref={inputRef}
      data-is-open={isOpenInput}
      variant={variant}
      onFocus={handleFocus}
      onBlur={handleOnBlur}
      disabled={disabled}
      onChange={handleInputChange}
      value={value}
      {...contextProps}
      {...props}
    />
  )
}

export default SearchInput
